import React, { ReactNode } from 'react';
type Variant = 'primary' | 'outline-dark' | 'outline-light' | 'ink';
type Size = 'md' | 'lg';
interface ButtonProps {
  children: ReactNode;
  variant?: Variant;
  size?: Size;
  href?: string;
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
  className?: string;
  ariaLabel?: string;
  external?: boolean;
}
const base = 'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-btn font-semibold transition-[background-color,border-color,color,transform] duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-afb-turquoise disabled:pointer-events-none disabled:opacity-60';
const variants: Record<Variant, string> = {
  primary: 'bg-afb-turquoise text-afb-ink hover:bg-afb-turquoise-2',
  'outline-dark': 'border border-white/25 text-white hover:border-white/60 hover:bg-white/[0.06]',
  'outline-light': 'border border-afb-ink/15 bg-white text-afb-ink hover:border-afb-ink/40',
  ink: 'bg-afb-ink text-white hover:bg-black'
};
const sizes: Record<Size, string> = {
  md: 'h-11 px-5 text-sm',
  lg: 'h-12 px-6 text-[15px]'
};
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  href,
  onClick,
  type = 'button',
  disabled,
  className = '',
  ariaLabel,
  external
}: ButtonProps) {
  const classes = `${base} ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} onClick={onClick} aria-label={ariaLabel} className={classes} {...external ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} data-id="element-552" data-mp="12lihta8rrecg">
        {children}
      </a>;
  }
  return <button type={type} onClick={onClick} disabled={disabled} aria-label={ariaLabel} className={classes} data-id="element-553" data-mp="17e1xqduxilkf">
      {children}
    </button>;
}